export default __webpack_public_path__ + "static/media/writting-illustration.74cb5446.svg";